import { message, Space, Tag, Tabs } from 'antd';
import { useDeliveryList } from './hooks/useDeliveryList';
import { useDeliveryColumns } from './components/useDeliveryColumns';
import { DeliveryFilterBar } from './components/DeliveryFilterBar';
import { DeliveryTable } from './components/DeliveryTable';
import { DeliveryModals } from './components/DeliveryModals';
import { DeliveryUtils } from './utils/DeliveryUtils';
import { usePermissions } from '../../../custom_hooks/permission/permission_hook';
import { exportPOCSV, editDelivery, updatePoDeliveryLegStatus } from './deliveryApi';
import { DataType, Project, Vendor, TermsAndCondition, PoPaymentTerm, Gst, Address, PoItem, Item } from "../../../interfaces/delivery.interface";
import { STATUS_TYPES } from "../../../constants/delivery.constants";

export type { DataType, Project, Vendor, TermsAndCondition, PoPaymentTerm, Gst, Address, PoItem, Item };
export { STATUS_TYPES as StatusTypes };

const DeliveryListV2 = () => {
  const { hasPermission } = usePermissions();
  const listState = useDeliveryList();
  
  const {
    activeTab, setActiveTab, data, setData, loading, total_pos, page, search, setSearch,
    fetchDeliveries, queryParams, tabParams, setPOData, setWarehouseDrawerVisible,
    setDeliveryLocationDrawerVisible, setVendor_name, editPO, setItemsToView,
    attachDeliveryDrawerVisible, setAttachDeliveryDrawerVisible, attachPODDrawerVisible,
    setAttachPODDrawerVisible, attachLRDrawerVisible, setAttachLRDrawerVisible,
    removeProof, deletePOFById, fetchPOFData, pofData, deliveriesCount,
    deliveriesPage, setDeliveriesPage, deliveriesView, etasView, dropdownVisible,
    setDropdownVisible, setCreated_at__gte, setCreated_at__lte, setDispatchTime__gte,
    setDispatchTime__lte, setDeliveryTime__gte, setDeliveryTime__lte, warehouseDrawerVisible,
    delivery_location_drawer_visible, eway_bill_drawer_visible, setEwayBillDrawerVisible,
    itemsToView, showLoginextCSVUpload, setShowLoginextCSVUpload, po_data, vendor_name,
    handleReset, handleSearchChange, sortVal, setSortVal,
    etasSearch, setEtasSearch,
    porterLinkDrawerData, setPorterLinkDrawerData,
    dispatchTimeDrawerVisible, setDispatchTimeDrawerVisible,
    escalationDrawerData, setEscalationDrawerData,
    city, setCity,
  } = listState;

  const { columns, deliveriesColumns } = useDeliveryColumns({
    activeTab, hasPermission, setPOData, setWarehouseDrawerVisible,
    setDeliveryLocationDrawerVisible, setVendor_name, setItemsToView,
    setAttachDeliveryDrawerVisible, removeProof,
    renderLRTags: (id) => DeliveryUtils.renderLRTags(id, pofData, deletePOFById),
    renderPOFTags: (id) => DeliveryUtils.renderPOFTags(id, pofData, deletePOFById),
    fetchPOFData, setAttachLRDrawerVisible, setAttachPODDrawerVisible,
    pofData, fetchDeliveries, setPorterLinkDrawerData,
    setDispatchTimeDrawerVisible, setEscalationDrawerData
  });

  const onDownloadClick = async (isItemWise = false) => {
    // ... download logic ...
    message.loading({ content: "Data will be sent to your email", key: "download" });
    await exportPOCSV({ ...tabParams, is_item_wise: isItemWise ? "true" : "false" });
  };

  const tabItems = [
    { label: "Express", key: "express" },
    { label: "Delivery Assigned", key: "delivery_assigned" },
    { label: "Outstation", key: "outstation" },
    { label: "Leftovers", key: "leftovers" },
    { label: "Dispatched", key: "dispatched" },
    { label: "Spill overs", key: "spill_overs" },
  ];

  return (
    <div className="mx-3 my-3 px-3 py-2 white-color-bg">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Delivery Orders</h3>
        <div className="d-flex justify-content-end align-items-center mb-3">
        <Space>
          {hasPermission("po.download") && (
            <Tag color="blue" onClick={() => onDownloadClick(false)} style={{ cursor: "pointer" }}>
              Download Data
            </Tag>
          )}
          {hasPermission("po.download") && (
            <Tag color="blue" onClick={() => onDownloadClick(true)} style={{ cursor: "pointer" }}>
              Download Item Wise Data
            </Tag>
          )}
        </Space>
      </div>
      </div>

      <DeliveryFilterBar
        sortVal={sortVal} setSortVal={setSortVal}
        dropdownVisible={dropdownVisible} setDropdownVisible={setDropdownVisible}
        handleReset={handleReset} search={search} setSearch={setSearch}
        handleSearchChange={handleSearchChange}
        handleSearch={(val) => {
          // Always pass trimmed value — empty string signals "clear search, reload tab data"
          fetchDeliveries({ page: 1, search: (val ?? "").trim() });
        }}
        setCreated_at__gte={setCreated_at__gte} setCreated_at__lte={setCreated_at__lte}
        setDispatchTime__gte={setDispatchTime__gte} setDispatchTime__lte={setDispatchTime__lte}
        setDeliveryTime__gte={setDeliveryTime__gte} setDeliveryTime__lte={setDeliveryTime__lte}
        deliveriesView={deliveriesView} etasView={etasView}
        etasSearch={etasSearch} setEtasSearch={setEtasSearch}
        city={city} setCity={setCity}
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        size="small"
        style={{ marginBottom: "1px" }}
      />

      

      <DeliveryTable
        loading={loading} data={data} setData={setData}
        columns={columns} deliveriesColumns={deliveriesColumns}
        deliveriesPage={deliveriesPage} setDeliveriesPage={setDeliveriesPage}
        deliveriesCount={deliveriesCount} deliveriesView={deliveriesView}
        etasView={etasView} page={page} total_pos={total_pos}
        fetchDeliveries={fetchDeliveries} queryParams={queryParams}
        etasSearch={etasSearch}
      />

      <DeliveryModals
        attachDeliveryDrawerVisible={attachDeliveryDrawerVisible}
        setAttachDeliveryDrawerVisible={setAttachDeliveryDrawerVisible}
        attachPODDrawerVisible={attachPODDrawerVisible}
        setAttachPODDrawerVisible={setAttachPODDrawerVisible}
        attachLRDrawerVisible={attachLRDrawerVisible}
        setAttachLRDrawerVisible={setAttachLRDrawerVisible}
        warehouseDrawerVisible={warehouseDrawerVisible}
        setWarehouseDrawerVisible={setWarehouseDrawerVisible}
        onWarehouseFinish={(vals) => editPO(po_data?.po?.id, { ...vals, po_delivery_status: "in_store" })}
        delivery_location_drawer_visible={delivery_location_drawer_visible}
        setDeliveryLocationDrawerVisible={setDeliveryLocationDrawerVisible}
        onDeliveryDetailsFinish={(vals) => editPO(po_data?.po?.id, { ...vals, po_delivery_status: "dispatched" })}
        eway_bill_drawer_visible={eway_bill_drawer_visible}
        setEwayBillDrawerVisible={setEwayBillDrawerVisible}
        onEwayBillDetailsFinish={(vals) => editPO(po_data?.po?.id, { ...vals })}
        itemsToView={itemsToView} setItemsToView={setItemsToView}
        showLoginextCSVUpload={showLoginextCSVUpload}
        setShowLoginextCSVUpload={setShowLoginextCSVUpload}
        fetchDeliveries={fetchDeliveries} po_data={po_data}
        vendor_name={vendor_name}
        porterLinkDrawerData={porterLinkDrawerData}
        setPorterLinkDrawerData={setPorterLinkDrawerData}
        onPorterLinkFinish={({ location_link, vehicle_number, driver_number }) => {
          const targetStatus = porterLinkDrawerData?.targetStatus || "dispatched";
          editDelivery({ id: porterLinkDrawerData?.id, location_link, vehicle_number, driver_number })
            .then(() => updatePoDeliveryLegStatus(porterLinkDrawerData?.id, targetStatus))
            .then(() => fetchDeliveries({ keepCurrentSearch: true }));
        }}
        dispatchTimeDrawerVisible={dispatchTimeDrawerVisible}
        setDispatchTimeDrawerVisible={setDispatchTimeDrawerVisible}
        escalationDrawerData={escalationDrawerData}
        setEscalationDrawerData={setEscalationDrawerData}
      />
    </div>
  );
};

export default DeliveryListV2;
